import { render, staticRenderFns } from "./IntegrationsAccessPanel.vue?vue&type=template&id=5274f5c3&scoped=true"
import script from "./IntegrationsAccessPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationsAccessPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IntegrationsAccessPanel.vue?vue&type=style&index=0&id=5274f5c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274f5c3",
  null
  
)

export default component.exports